<template>
  <!-- 省市区选择框 -->
  <van-action-sheet v-model="modelValue" @close="cancelAddressSelect">
    <van-area
      title="选择地区"
      :area-list="areaList"
      @cancel="cancelAddressSelect"
      @confirm="confirmAddressSelect"
    />
  </van-action-sheet>
</template>
<script>
import { areaList } from '@vant/area-data'
export default {
  name: 'AreaBox',
  props: {
    value: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      areaList: Object.freeze(areaList),
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  methods: {
    cancelAddressSelect() {
      this.modelValue = false
    },
    // 确认选择省市区
    confirmAddressSelect(area) {
      this.$emit('confirm', area)
      this.modelValue = false
    },
  },
}
</script>

<style scoped lang="scss"></style>
